import { ErrorToast as MMErrorToast } from '@magpie/ui-checkout';
import { useClientSettings, useExpressWidgetError } from '../../hooks';

const ErrorToast = () => {
    const { expressWidgetError, setExpressWidgetError } = useExpressWidgetError();
    const { expressCheckoutOptions } = useClientSettings();

    if (!expressWidgetError || !expressCheckoutOptions?.enableToastMessaging) {
        return null;
    }

    const handleClose = () => {
        setExpressWidgetError(null);
    };

    return (
        <MMErrorToast
            onDismiss={handleClose}
            headline={expressWidgetError.headline}
            message={expressWidgetError.message}
            zIndex={101} // to keep error toast over header with z-index=20 and PayPal button with z-index=100
        />
    );
};

export default ErrorToast;
